import { DocumentSettings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentModal/types';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID.ts';
import { DocumentSignatureType, DocumentTemplateType } from '@dealstack/shared/lib/generated';

export const TemplatePredefinedOptions: Record<DocumentTemplateType, DocumentSettings> = {
	[DocumentTemplateType.CUSTOM]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.CUSTOM,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.GDPR_NOTICE]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.GDPR_NOTICE,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.NOTICE]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.NOTICE,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.NOTICE_REQUIRING_ACKNOWLEDGMENT]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.NOTICE_REQUIRING_ACKNOWLEDGMENT,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.AGREEMENT]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.AGREEMENT,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: true,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.AGREEMENT_ADVANCED_SIGNATURE]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.AGREEMENT_ADVANCED_SIGNATURE,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: true,
		isToBeSubmitted: false,
		individualScheduleRequired: true,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.SCHEDULE]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.SCHEDULE,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: true,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.FORM]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.FORM,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.SUBMITTABLE,
		isSignatureAdvanced: false,
		isToBeSubmitted: true,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.FORM_S431]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.FORM_S431,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.WET_INK,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [
			{
				chipId: generateUUID(),
				name: 'Counterparty',
				amount: 1,
			},
		],
		counterpartiesIncluded: true,
	},
	[DocumentTemplateType.PRE_FILLABLE_FORM]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.PRE_FILLABLE_FORM,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.SUBMITTABLE,
		isSignatureAdvanced: false,
		isToBeSubmitted: true,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.UK_DEED]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.UK_DEED,
		witnessesRequired: true,
		signatureType: DocumentSignatureType.WET_INK,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.POWER_OF_ATTORNEY]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.POWER_OF_ATTORNEY,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.SIDE_LETTER]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.SIDE_LETTER,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.ELECTRONIC,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: true,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.ANNUAL_REPORT]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.ANNUAL_REPORT,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.VALUATION]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.VALUATION,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
	[DocumentTemplateType.RESOLUTION]: {
		documentWorkflowFileId: '',
		templateType: DocumentTemplateType.RESOLUTION,
		witnessesRequired: false,
		signatureType: DocumentSignatureType.REVIEW,
		isSignatureAdvanced: false,
		isToBeSubmitted: false,
		individualScheduleRequired: false,
		counterparties: [],
		counterpartiesIncluded: false,
	},
};
